// extracted by mini-css-extract-plugin
export default {"main":"Main_main__tKBy6","mainImg":"Main_mainImg__xKDA1","mainText":"Main_mainText__hWG9f"};